import { render, staticRenderFns } from "./again-buy.vue?vue&type=template&id=650faa92&scoped=true&"
import script from "./again-buy.vue?vue&type=script&lang=js&"
export * from "./again-buy.vue?vue&type=script&lang=js&"
import style0 from "./again-buy.vue?vue&type=style&index=0&id=650faa92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650faa92",
  null
  
)

export default component.exports